import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

type WrapperProps = {
  hasError: string
  instant_dashing_v2: boolean
}

export const Wrapper = styled.div`
  margin-top: ${(p: WrapperProps) => (p.hasError ? '64px' : 'auto')};
  text-align: ${(p: WrapperProps) =>
    p.instant_dashing_v2 ? 'center' : 'unset'};
`

Wrapper.defaultProps = {
  instant_dashing_v2: false,
}

export const BulletItem = styled.li`
  margin-bottom: ${Spacing.Small}px;
`
